export default __webpack_public_path__ + "static/860-ec55871cb55cefdfa3715a9c2503b718.gif";